export var LanguageEnum = function (LanguageEnum) {
  LanguageEnum["ENGLISH"] = "en";
  LanguageEnum["GERMAN"] = "de";
  return LanguageEnum;
}({});